// extracted by mini-css-extract-plugin
module.exports = {"root":"DlpBreadcrumbsSection_root__hCeTs"};